module.exports = __webpack_public_path__ + "static/img/zenryoku_logo.5c97ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/zenryoku_logo.png
// module id = 2u4f
// module chunks = 0